import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=d63fe994&scoped=true"
import script from "./input-textarea.vue?vue&type=script&lang=js"
export * from "./input-textarea.vue?vue&type=script&lang=js"
import style0 from "./input-textarea.vue?vue&type=style&index=0&id=d63fe994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63fe994",
  null
  
)

export default component.exports